import {
    FETCH_GOLF_SCORECARD,
    FETCH_GOLF_SCORECARD_FETCHING,
    FETCH_GOLF_SCORECARD_SUCCESS,
    FETCH_GOLF_SCORECARD_FAIL,
    UPDATE_GOLF_SCORECARD,
    UPDATE_GOLF_SCORECARD_UPDATING,
    UPDATE_GOLF_SCORECARD_SUCCESS,
    UPDATE_GOLF_SCORECARD_FAIL,
    FETCH_GOLF_SCORECARD_DETAIL,
    FETCH_GOLF_SCORECARD_DETAIL_FETCHING,
    FETCH_GOLF_SCORECARD_DETAIL_SUCCESS,
    FETCH_GOLF_SCORECARD_DETAIL_FAIL,
    DELETE_GOLF_SCORECARD,
    DELETE_GOLF_SCORECARD_DELETING,
    DELETE_GOLF_SCORECARD_SUCCESS,
    DELETE_GOLF_SCORECARD_FAIL
} from 'actions/golfScorecardActions';

const INITIAL_STATE = {
    scorecards: {},
    scorecardFetching: false,
    scorecardFetchSuccess: false,
    scorecardFetchFail: false,
    scorecardUpdating: false,
    scorecardUpdateFail: false,
    scorecardUpdateSuccess: false,
    scorecardDetailFetching: false,
    scorecardDetailFetchSuccess: false,
    scorecardDetailFetchFail: false,
    scorecardDeleting: false,
    scorecardDeleteFail: false,
    scorecardDeleteSuccess: false,
    scorecardFetchFailStatus: undefined
};

// ======= Fetching Handlers =======
const scorecardFetching = (state) => {
    return {
        ...state,
        scorecardFetching: true,
        scorecardFetchSuccess: false,
        scorecardFetchFail: false
    };
};

const scorecardFetchFinished = (success) => (state, action) => {
    return {
        ...state,
        scorecards: success
            ? {
                  ...state.scorecards,
                  [action.scorecard.id]: {
                      ...state.scorecards[action.scorecard.id],
                      scorecard: action.scorecard
                  }
              }
            : state.scorecards,
        scorecardFetching: false,
        scorecardFetchSuccess: success,
        scorecardFetchFail: !success,
        scorecardFetchFailStatus: action.status
    };
};

const scorecardDetailFetching = (state) => {
    return {
        ...state,
        scorecardFetching: true,
        scorecardFetchSuccess: false,
        scorecardFetchFail: false,
        scorecardDetailFetching: true,
        scorecardDetailFetchSuccess: false,
        scorecardDetailFetchFail: false
    };
};

const scorecardDetailFetchFinished = (success) => (state, action) => {
    return {
        ...state,
        scorecards: success
            ? {
                  ...state.scorecards,
                  [action.scorecardId]: action.scorecardDetail
              }
            : state.scorecards,
        scorecardFetching: false,
        scorecardFetchSuccess: success,
        scorecardFetchFail: !success,
        scorecardDetailFetching: false,
        scorecardDetailFetchSuccess: success,
        scorecardDetailFetchFail: !success
    };
};

// ======= Updating Handlers =======
const updateScorecardUpdating = (state) => {
    return {
        ...state,
        scorecardUpdating: true,
        scorecardUpdateFail: false,
        scorecardUpdateSuccess: false
    };
};

const updateScorecardUpdateSuccess = (state, action) => {
    return {
        ...state,
        // update response does not include stats etc, need to fetch detail again
        // scorecards: {
        //     ...state.scorecards,
        //     [action.scorecard.id]: {
        //         ...state.scorecards[action.scorecard.id],
        //         scorecard: action.scorecard
        //     }
        // },
        scorecardUpdating: false,
        scorecardUpdateFail: false,
        scorecardUpdateSuccess: true
    };
};

const updateScorecardUpdateFail = (state) => {
    return {
        ...state,
        scorecardUpdating: false,
        scorecardUpdateFail: true,
        scorecardUpdateSuccess: false
    };
};

// ======= Deleting Handlers =======
const deleteScorecardDeleting = (state) => {
    return {
        ...state,
        scorecardDeleting: true,
        scorecardDeleteFail: false,
        scorecardDeleteSuccess: false
    };
};

const deleteScorecardDeleteSuccess = (state, action) => {
    delete state.scorecards[action.scorecardId];
    return {
        ...state,
        scorecards: {
            ...state.scorecards
        },
        scorecardDeleting: false,
        scorecardDeleteFail: false,
        scorecardDeleteSuccess: true
    };
};

const deleteScorecardDeleteFail = (state) => {
    return {
        ...state,
        scorecardDeleting: false,
        scorecardDeleteFail: true
    };
};

// ======= Handler Assignments =======
const handlers = {
    [FETCH_GOLF_SCORECARD_FETCHING]: scorecardFetching,
    [FETCH_GOLF_SCORECARD_SUCCESS]: scorecardFetchFinished(true),
    [FETCH_GOLF_SCORECARD_FAIL]: scorecardFetchFinished(false),
    [UPDATE_GOLF_SCORECARD_UPDATING]: updateScorecardUpdating,
    [UPDATE_GOLF_SCORECARD_SUCCESS]: updateScorecardUpdateSuccess,
    [UPDATE_GOLF_SCORECARD_FAIL]: updateScorecardUpdateFail,
    [FETCH_GOLF_SCORECARD_DETAIL_FETCHING]: scorecardDetailFetching,
    [FETCH_GOLF_SCORECARD_DETAIL_SUCCESS]: scorecardDetailFetchFinished(true),
    [FETCH_GOLF_SCORECARD_DETAIL_FAIL]: scorecardDetailFetchFinished(false),
    [DELETE_GOLF_SCORECARD_DELETING]: deleteScorecardDeleting,
    [DELETE_GOLF_SCORECARD_SUCCESS]: deleteScorecardDeleteSuccess,
    [DELETE_GOLF_SCORECARD_FAIL]: deleteScorecardDeleteFail
};

// ======= Default Action =======
export default function golfScorecard(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// ======= Selectors =======
export const getScorecard = (state, scorecardId) => {
    const scorecardDetail = getScorecardDetail(state, scorecardId);
    return scorecardDetail.scorecard || {};
};

export const isScorecardFetching = (state) => {
    return state.golfScorecard.scorecardFetching;
};

export const didScorecardFetchFail = (state) => {
    return state.golfScorecard.scorecardFetchFail;
};

export const getScorecardFetchFailStatus = (state) => {
    return state.golfScorecard.scorecardFetchFailStatus;
};

export const didScorecardFetchSucceed = (state) => {
    return state.golfScorecard.scorecardFetchSuccess;
};

export const isScorecardUpdating = (state) => {
    return state.golfScorecard.scorecardUpdating;
};

export const didScorecardUpdateFail = (state) => {
    return state.golfScorecard.scorecardUpdateFail;
};

export const didScorecardUpdateSucceed = (state) => {
    return state.golfScorecard.scorecardUpdateSuccess;
};

export const getScorecardDetail = (state, scorecardId) => {
    return state.golfScorecard.scorecards[scorecardId] || {};
};

export const isScorecardDetailFetching = (state) => {
    return state.golfScorecard.scorecardDetailFetching;
};

export const didScorecardDetailFetchFail = (state) => {
    return state.golfScorecard.scorecardDetailFetchFail;
};

export const didScorecardDetailFetchSucceed = (state) => {
    return state.golfScorecard.scorecardDetailFetchSuccess;
};

export const getNextScorecardId = (state, scorecardId) => {
    const scorecardDetail = getScorecardDetail(state, scorecardId);
    return scorecardDetail.nextPreviousScorecardIdsApiModel?.nextScorecardId;
};

export const getPreviousScorecardId = (state, scorecardId) => {
    const scorecardDetail = getScorecardDetail(state, scorecardId);
    return scorecardDetail.nextPreviousScorecardIdsApiModel?.previousScorecardId;
};

export const getShotCounts = (state, scorecardId) => {
    const scorecardDetail = getScorecardDetail(state, scorecardId);
    return scorecardDetail.shotCounts || [];
};

export const getScorecardStats = (state, scorecardId) => {
    const scorecardDetail = getScorecardDetail(state, scorecardId);
    return scorecardDetail.scorecardStats || {};
};

export const getLongestShotInMeters = (state, scorecardId) => {
    const scorecardDetail = getScorecardDetail(state, scorecardId);
    return scorecardDetail?.longestShotInMeters;
};

export const getGuestScorecardStats = (state, scorecardId) => {
    const scorecardDetail = getScorecardDetail(state, scorecardId);
    return scorecardDetail.guestScorecardStats || [];
};

export const isScorecardDeleting = (state) => {
    return state.golfScorecard.scorecardDeleting;
};

export const didScorecardDeleteFail = (state) => {
    return state.golfScorecard.scorecardDeleteFail;
};

export const didScorecardDeleteSucceed = (state) => {
    return state.golfScorecard.scorecardDeleteSuccess;
};

// ======= Actions =======

export function fetchScorecard(scorecardId) {
    return {
        type: FETCH_GOLF_SCORECARD,
        scorecardId: scorecardId
    };
}

export function updateScorecard(scorecardId, patches) {
    return {
        type: UPDATE_GOLF_SCORECARD,
        scorecardId: scorecardId,
        patches: patches
    };
}

export function fetchScorecardDetail(scorecardId, locale) {
    return {
        type: FETCH_GOLF_SCORECARD_DETAIL,
        scorecardId: scorecardId,
        locale: locale
    };
}

export function deleteScorecard(scorecardId) {
    return {
        type: DELETE_GOLF_SCORECARD,
        scorecardId: scorecardId
    };
}
